import { freeUserUpgradeStep } from '../utils';

export const dashboardHomeBusinessTour = {
  tourKey: 'dashboard_home_business',
  conditions: {
    orgTypes: ['business'],
    userTypes: ['admin', 'staff'],
    plans: null,
  },
  steps: [
    {
      // No target - shows a centered welcome popover without highlighting any element
      title: 'tours.dashboard-home-business.welcome.title',
      content: 'tours.dashboard-home-business.welcome.content',
      placement: 'center',
    },
    {
      target: '[data-tour="stats-food-rescued"]',
      title: 'tours.dashboard-home-business.food-donated.title',
      content: 'tours.dashboard-home-business.food-donated.content',
      placement: 'right',
    },
    {
      target: '[data-tour="stats-total-count"]',
      title: 'tours.dashboard-home-business.total-donations.title',
      content: 'tours.dashboard-home-business.total-donations.content',
      placement: 'right',
    },
    {
      target: '[data-tour="stats-impact"]',
      title: 'tours.dashboard-home-business.impact.title',
      content: 'tours.dashboard-home-business.impact.content',
      placement: 'top',
    },
    freeUserUpgradeStep,
  ],
};
